export default __webpack_public_path__ + "static/media/icon_key_24_Regular_green.71aed3fb.svg";